<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card class="card-usuarios text-center m-4">
      <b-row class="mb-4">
        <b-col class="col-6">
          <label > <b> Buscar por nombre o rfc:  </b> </label>
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-icon icon="file-earmark-spreadsheet"></b-icon>
            </b-input-group-prepend>
            <b-form-input
                v-model="rfc"
                placeholder="Ingrese nombre o RFC"
                type="text"
                v-on:keypress="esLetra($event)"
                v-b-tooltip.hover
                v-on:keyup.enter="obtenerDatosPorNombre(rfc)"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col class="col-2"></b-col>
        <b-col class="col-4">
          <br>
          <b-button pill variant="primary" class="m-1" size="sm" @click="agregarFiscales()"
                     v-b-tooltip.hover title="Agregar dato fiscal">
            <b-icon
                icon="person-plus"
                variant="ligth"
            ></b-icon>
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table
              :fields="fields"
              :items="lstRfc"
              responsive
              class="parrafos"
              thead-tr-class="columnas"
              fixed
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
          >
              <template v-slot:cell(tipoPersona)="row">
                <label v-if="row.item.tipoPersona === 1">Moral</label>
                <label v-else>Fisica</label>
              </template>
              <template v-slot:cell(Acciones)="row">
              <b-button v-if="row.item.activo" class="mr-1 marginbotones" pill variant="outline-primary" size="sm"
                        v-b-tooltip.hover title="Editar dato fiscal" @click="editarDatosFiscales(row.item)">
                <b-icon icon="pencil" ></b-icon>
              </b-button>
              <b-button v-if="row.item.activo" class="mr-1 marginbotones" pill variant="outline-danger" size="sm"
                        v-b-tooltip.bottomleft title="Inactivar RFC" @click="inactivarRFC(row.item.idPlanDatoFiscal)">
                <b-icon icon="trash" ></b-icon>
              </b-button>
                <b-button v-if="!row.item.activo" class="mr-1 marginbotones" pill variant="outline-success" size="sm"
                          v-b-tooltip.bottomleft title="Activar RFC" @click="inactivarRFC(row.item.idPlanDatoFiscal)">
                <b-icon icon="arrow-clockwise" ></b-icon>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

        <b-pagination
            first-number
            last-number
            v-if="lstRfc.length > 0"
            align="center"
            v-model="paginaActual"
            :total-rows="lstRfc.length "
            :per-page="registrosPorPagina"
        ></b-pagination>
    </b-card>

    <b-modal
        id="showDatosFiscales"
        ref="showFiscales"
        title="Agregar Datos Fiscales"
        size="lg"
        centered
        hide-footer
    >

      <AgregarDatosFiscales :datosFactura="dataFactura" :editar="editar" :fiscales="fiscales" @obtenerListaRfc="obtenerRfc()"></AgregarDatosFiscales>


    </b-modal>

  </div>
</template>

<script>


import AgregarDatosFiscales from "@/components/AgregarDatosFiscales";
export default {
  name: "RazonSocial",
  components: {AgregarDatosFiscales},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    lstRfc:[],
    rfc: null,
    showFiscales: false,
    loaderAcciones: false,
    dataFactura: null,
    idPlan: null,
    fields: [
      { key: "idPlanDatoFiscal", label: "Id Plan Dato Fiscal", sortable: true },
      { key: "rfc", label: "RFC", sortable: true },
      { key: "nombreCompleto", label: "Nombre Completo", sortable: true },
      { key: "tipoPersona", label: "Tipo Persona", sortable: true },
      { key: "correo", label: "Correo", sortable: true },
      { key: "cp", label: "Código Postal", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 1,
    currentPage: 1,
    fiscales: null,
    editar: false,
  }),
  mounted() {
    this.idPlan = this.$route.params.id;
    this.obtenerRfc();

  },
  methods:{
    obtenerDatosPorNombre(nombre){

        var inputTxt = nombre.trim().toLowerCase().toUpperCase();
        const datos = {
          nombrePaciente: inputTxt,
          idPlan: this.idPlan
        }
        this.$http
            .post(
                this.$api +
                "portalautoservicio/facturacion/obtenerFiscalesNombreCompleto", datos
            )
            .then((response) => {
              if (response.status === 200) {
                this.lstRfc = response.data.data
              }
            }).finally(()=> {
        })

      },
    editarDatosFiscales(fiscales){
      this.editar = true;
      this.fiscales = fiscales;
      this.$refs["showFiscales"].show();
    },
    agregarFiscales(){
      this.dataFactura = {
        idEmpresa: null,
        idCuenta : null,
        idPlan : this.idPlan,
        ajuste: null,
        idArchivo : null
      }
      this.fiscales = null;
      this.editar = false;
      this.$refs["showFiscales"].show();
    },
    obtenerRfc() {
      this.$refs["showFiscales"].hide();
      this.blnLoaderRFC = true;
      const datos = {
        idPlan: this.idPlan,
        registroActivo: false
      }
      this.$http
          .post(
              this.$api +
              "portalautoservicio/obtener/datosFiscales", datos
          )
          .then((response) => {
            if (response.data.data) {
              this.lstRfc = [];
              this.lstRfc = response.data.data;
            }
          })
          .catch(function (error) {
            console.error(error);
          })
          .finally(() => {this.blnLoaderRFC = false;});
    },
    inactivarRFC(registro){
      this.$http
          .put(
              this.$api +
              "portalautoservicio/facturacion/activarDesactivar?idPlanDatoFiscal=" +
              registro
          )
          .then((response) => {
            if (response.data.data) {
              this.obtenerRfc()
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: response.data.message,
              });
            }
          })
    },
    cerrarModal(){
      this.showFiscales = false;
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>
.card-usuarios{
  border-radius: 25px;
  box-shadow: 3px 4px 7px 2px rgb(110 110 110 / 43%);
  margin: 1vw;
}
</style>
